import { Bill } from '../types'

// Bills retain their original invoice total. Cash and return credit settle it separately.
export const billRemainingBalance = (bill: Bill): number => {
  const invoiceCents = Math.round(bill.summary.net_payable * 100)
  const paidCents = Math.round((bill.paid_amount ?? 0) * 100)
  const returnedCents = Math.round((bill.returned_amount ?? 0) * 100)
  return (invoiceCents - paidCents - returnedCents) / 100
}
